import { BasePeerToPeerCampaignAction } from "./BasePeerToPeerCampaignAction";

import { FormButton } from "@/forms-design-system/FormButton/FormButton";
import { useTranslate } from "@/hooks/useTranslate";
import { ArrowDiagonalRight } from "@/icons/outlined";
type PeerToPeerPrimaryCampaignFundraiseCampaignActionProps = {
  canCreateTeamCampaigns: boolean;
  canCreateIndividualCampaigns: boolean;
  hasRegistration: boolean;
  onClick?: () => void;
};

export const PeerToPeerPrimaryCampaignFundraiseCampaignAction = ({
  canCreateTeamCampaigns,
  canCreateIndividualCampaigns,
  hasRegistration,
  onClick,
}: PeerToPeerPrimaryCampaignFundraiseCampaignActionProps) => {
  const { t } = useTranslate();

  const getDescription = () => {
    if (hasRegistration) {
      return t("donationForm", "peerToPeer.description.fundraiseOnly");
    }

    if (canCreateTeamCampaigns) {
      return canCreateIndividualCampaigns
        ? t("donationForm", "peerToPeer.description.createTeamJoinOrSolo")
        : t("donationForm", "peerToPeer.description.createTeamOrJoin");
    }
    return canCreateIndividualCampaigns
      ? t("donationForm", "peerToPeer.description.createCampaign")
      : t("donationForm", "peerToPeer.description.joinTeam");
  };

  return (
    <BasePeerToPeerCampaignAction
      title={t("donationForm", "peerToPeer.title.wantToFundraise")}
      description={getDescription()}
      slots={{
        button: (
          <FormButton variant="outline" endIcon={<ArrowDiagonalRight />} onClick={onClick} data-test="fundraise-button">
            {t("donationForm", hasRegistration ? "peerToPeer.button.fundraiseOnly" : "peerToPeer.button.fundraise")}
          </FormButton>
        ),
      }}
    />
  );
};
